import {Component, EventEmitter, Input, Output} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ApiService} from "../../services/api.service";
import {range} from "rxjs";

import { Pagination } from './pagination.model';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {

  @Input() pagination: Pagination;
  @Output() pageChanged = new EventEmitter<number>();
  @Output() perPageChanged = new EventEmitter<number>();

  get pages(): (number | string)[] {
    const total = this.pagination.last_page;
    const current = this.pagination.current_page;
    const range: (number | string)[] = [];

    if (total <= 7) {
      // If total pages are less than or equal to 7, show all pages
      for (let i = 1; i <= total; i++) {
        range.push(i);
      }
    } else {
      // Always include the first 5 pages if current is near the start
      if (current <= 4) {
        for (let i = 1; i <= 5; i++) {
          range.push(i);
        }
        range.push('...');
        range.push(total);
      }
      // Show the last 5 pages if current is near the end
      else if (current >= total - 3) {
        range.push(1);
        range.push('...');
        for (let i = total - 4; i <= total; i++) {
          range.push(i);
        }
      }
      // Display first page, range around current, and last page with ellipses
      else {
        range.push(1);
        range.push('...');
        range.push(current - 1, current, current + 1);
        range.push('...');
        range.push(total);
      }
    }

    return range;
  }


  onSelectPage(page): void {
    if (typeof page === 'number') {
      this.pageChanged.emit(page);
    }
  }

  onPerPageChange(event: Event): void {
    const selectedValue = (event.target as HTMLSelectElement).value;
    this.pagination.per_page = Number(selectedValue);
    this.pagination.current_page = 1; // Reset to the first page
    this.perPageChanged.emit(this.pagination.per_page);
  }

}
